import { render, staticRenderFns } from "./priceToDetail.vue?vue&type=template&id=cd326b18&scoped=true"
import script from "./priceToDetail.vue?vue&type=script&lang=js"
export * from "./priceToDetail.vue?vue&type=script&lang=js"
import style0 from "./priceToDetail.vue?vue&type=style&index=0&id=cd326b18&prod&scoped=true&lang=css"
import style1 from "./priceToDetail.vue?vue&type=style&index=1&id=cd326b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd326b18",
  null
  
)

export default component.exports